import styled from 'styled-components';
import BaseBackdrop from 'components/Backdrop';

export const Backdrop = styled(BaseBackdrop)`
  overflow-y: auto;
  z-index: ${({ theme }) => theme.zIndex.dialog};
`;
